import { Component, Input } from '@angular/core';
import { TabService } from '@services/tab/tab.service';
import { AiChatPromptService } from '../../ai-chat/ai-chat-prompt.service';

@Component({
    standalone: false,
    selector: 'app-patient-actions-button',
    templateUrl: './patient-actions-button.component.html',
    styleUrls: ['./patient-actions-button.component.scss'],
})
export class PatientActionsButtonComponent {
    @Input() email: string;
    @Input() orders: any[] = [];

    get orderCount(): number {
        return this.orders?.length ?? 0;
    }

    constructor(
        private tabService: TabService,
        private aiChatPromptService: AiChatPromptService,
    ) {}

    viewPatientRecord(): void {
        if (this.email?.trim()) {
            this.tabService.navigateWithDisplayName(
                ['dashboard', 'patients', 'patient-record', this.email.trim()],
                this.email.trim()
            );
        }
    }

    viewOrders(): void {
        if (this.email?.trim()) {
            this.tabService.navigateWithDisplayName(
                ['dashboard', 'patients', 'patient-record', this.email.trim()],
                this.email.trim(),
                { queryParams: { tab: 'orders' } }
            );
        }
    }

    analyzeWithAi(): void {
        if (this.email?.trim()) {
            const prompt = `Please retrieve and analyze the patient data for ${this.email.trim()}. Provide a summary of their record, including orders, treatment plans, and any notable observations.`;
            this.aiChatPromptService.sendPrompt(prompt);
        }
    }
}
